module.exports = __webpack_public_path__ + "img/mobile_img.9abffe48.png";